<template>
  <div class="container-fluid">
    <v-toolbar dense
               src="https://cdn.vuetifyjs.com/images/backgrounds/vbanner.jpg"
    >
      <v-spacer></v-spacer>
      <v-btn
        v-if="toolbarButtonsVisible"
        class="ma-2"
        color="error"
        outlined
        @click="exportExcel"
      >
        Excel Export
      </v-btn>
      <v-btn
        v-if="toolbarButtonsVisible"
        class="ma-2"
        color="error"
        outlined
        @click="exportPdf"
      >
        PDF Export
      </v-btn>
    </v-toolbar>
    <v-tabs
      v-model="activeTab"
      background-color="indigo"
      dark
      fixed-tabs
    >
      <v-tab>
        K rozvozu
      </v-tab>
      <v-tab-item>
        <v-data-table
          ref="deliveriesTable"
          :headers="headers"
          :items="notPickedDeliveries"
          :items-per-page="-1"
          :loading="loadingDeliveries"
          :search="search"
          class="elevation-1"
          item-key="index"
          locale="cs"
          show-expand
          single-expand
          sort-by="id"
        >
          <template v-slot:top>
            <v-toolbar color="white" flat>
              <v-toolbar-title>Rozvoz</v-toolbar-title>
              <v-divider
                class="mx-4"
                inset
                vertical
              ></v-divider>
              <v-spacer>Dnešní den</v-spacer>
              <v-menu
                v-model="dateFilterPicker"
                :nudge-right="40"
                close-on-content-click
                min-width="auto"
                offset-y
                transition="scale-transition"
              >
                <template v-slot:activator="{ on, attrs }">
                  <!-- ten filtr -->
                  <v-text-field
                    v-model="dateFilter"
                    hide-details
                    label="Filtr Data"
                    prepend-icon="mdi-calendar"
                    readonly
                    single-line
                    v-bind="attrs"
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="dateFilter"
                  first-day-of-week="1"
                  @input="dateFilterPicker = false"
                ></v-date-picker>
              </v-menu>
              <v-select
                v-model="selectedTime"
                :items="timeTypes"
                deletable-chips
                hide-details
                item-text="name"
                label="Filtr denní"
                return-object
                single-line
                small-chips
              ></v-select>
              <v-text-field
                v-model="search"
                append-icon="mdi-magnify"
                hide-details
                label="Vyhledávání"
                single-line
              ></v-text-field>
            </v-toolbar>
          </template>
          <template v-slot:expanded-item="{ headers, item }">
            <td :colspan="headers.length">
              <v-container>
                <v-row>
                  <v-col>
                    <v-data-table
                      :headers="deliveryItemsHeaders"
                      :items="item.items"
                    >
                      <template v-slot:item.actions="{ item }">
                        <v-btn
                          v-if="!item.delivered && currentUser.roleId === 4"
                          :disabled="loadingDeliveries"
                          color="success"
                          outlined
                          @click="take(item)"
                        >
                          Převzít
                        </v-btn>
                      </template>
                    </v-data-table>
                  </v-col>
                </v-row>
              </v-container>
            </td>
          </template>
        </v-data-table>
      </v-tab-item>
      <v-tab
      >
        Převzato
      </v-tab>
      <v-tab-item>
        <v-data-table
          ref="deliveriesTable"
          :headers="currentUser.roleId === 4 ? headers : headersWithDriver"
          :items="pickedDeliveries"
          :items-per-page="-1"
          :loading="loadingDriverDeliveries"
          :search="search"
          :single-select="singleSelect"
          class="elevation-1"
          item-key="index"
          locale="cs"
          show-expand
          single-expand
          sort-by="id"
        >
          <template v-slot:top>
            <v-toolbar color="white" flat>
              <v-toolbar-title>Rozvoz</v-toolbar-title>
              <v-divider
                class="mx-4"
                inset
                vertical
              ></v-divider>
              <v-spacer>Dnešní den</v-spacer>
              <v-menu
                v-model="dateFilterPickerPicked"
                :nudge-right="40"
                close-on-content-click
                min-width="auto"
                offset-y
                transition="scale-transition"
              >
                <template v-slot:activator="{ on, attrs }">
                  <!-- ten filtr -->
                  <v-text-field
                    v-model="dateFilterPicked"
                    hide-details
                    label="Filtr Data"
                    prepend-icon="mdi-calendar"
                    readonly
                    single-line
                    v-bind="attrs"
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="dateFilterPicked"
                  first-day-of-week="1"
                  @input="dateFilterPickerPicked = false"
                ></v-date-picker>
              </v-menu>
              <v-select
                v-model="selectedTime"
                :items="timeTypes"
                deletable-chips
                hide-details
                item-text="name"
                label="Filtr denní"
                return-object
                single-line
                small-chips
              ></v-select>
              <v-text-field
                v-model="search"
                append-icon="mdi-magnify"
                hide-details
                label="Vyhledávání"
                single-line
              ></v-text-field>
            </v-toolbar>
          </template>
          <template v-slot:expanded-item="{ headers, item }">
            <td :colspan="headers.length">
              <v-container>
                <v-row>
                  <v-col>
                    <v-data-table
                      :headers="deliveryItemsHeaders"
                      :items="item.items"
                    >
                      <template v-slot:item.actions="{ item }">
                        <v-btn
                          v-if="!item.delivered && currentUser.roleId === 4"
                          :disabled="loadingDriverDeliveries"
                          color="success"
                          outlined
                          @click="finish(item)"
                        >
                          Dokončit
                        </v-btn>
                      </template>
                    </v-data-table>
                  </v-col>
                </v-row>
              </v-container>
            </td>
          </template>
        </v-data-table>
      </v-tab-item>
      <v-tab
      >
        Převzato doručeno
      </v-tab>
      <v-tab-item>
        <v-data-table
          ref="deliveriesTable"
          :headers="currentUser.roleId === 4 ? headers : headersWithDriver"
          :items="pickedDeliveredDeliveries"
          :items-per-page="-1"
          :loading="loadingDriverDeliveries"
          :search="search"
          :single-select="singleSelect"
          class="elevation-1"
          item-key="index"
          locale="cs"
          show-expand
          single-expand
          sort-by="id"
        >
          <template v-slot:top>
            <v-toolbar color="white" flat>
              <v-toolbar-title>Převzato doručeno</v-toolbar-title>
              <v-divider
                class="mx-4"
                inset
                vertical
              ></v-divider>
              <v-spacer>Dnešní den</v-spacer>
              <v-menu
                v-model="dateFilterPickerDelivered"
                :nudge-right="40"
                close-on-content-click
                min-width="auto"
                offset-y
                transition="scale-transition"
              >
                <template v-slot:activator="{ on, attrs }">
                  <!-- ten filtr -->
                  <v-text-field
                    v-model="dateFilterDelivered"
                    hide-details
                    label="Filtr Data"
                    prepend-icon="mdi-calendar"
                    readonly
                    single-line
                    v-bind="attrs"
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="dateFilterDelivered"
                  first-day-of-week="1"
                  @input="dateFilterPickerDelivered = false"
                ></v-date-picker>
              </v-menu>
              <v-select
                v-model="selectedTime"
                :items="timeTypes"
                deletable-chips
                hide-details
                item-text="name"
                label="Filtr denní"
                return-object
                single-line
                small-chips
              ></v-select>
              <v-text-field
                v-model="search"
                append-icon="mdi-magnify"
                hide-details
                label="Vyhledávání"
                single-line
              ></v-text-field>
            </v-toolbar>
          </template>
          <template v-slot:expanded-item="{ headers, item }">
            <td :colspan="headers.length">
              <v-container>
                <v-row>
                  <v-col>
                    <v-data-table
                      :headers="deliveryItemsHeaders"
                      :items="item.items"
                    >
                    </v-data-table>
                  </v-col>
                </v-row>
              </v-container>
            </td>
          </template>
        </v-data-table>
      </v-tab-item>
    </v-tabs>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex'
import ExcelJS from 'exceljs'
import pdfMake from 'pdfmake/build/pdfmake'
import pdfFonts from 'pdfmake/build/vfs_fonts'

export default {
  Name: 'Delivery',
  data: () => ({
    dateFilterPicked: new Date().toISOString().slice(0, 10),
    dateFilterPickerPicked: false,
    dateFilter: new Date().toISOString().slice(0, 10),
    dateFilterPicker: false,
    dateFilterDelivered: new Date().toISOString().slice(0, 10),
    dateFilterPickerDelivered: false,
    selectedTime: null,
    activeTab: null,
    toolbarButtonsVisible: false,
    loadingDeliveries: false,
    loadingDriverDeliveries: false,
    singleSelect: false,
    selected: [],
    deliveryItemsHeaders: [
      {
        text: 'Název',
        value: 'name'
      },
      {
        text: 'Typ',
        value: 'foodTypesStr'
      },
      {
        text: 'Množství',
        value: 'quantity'
      },
      {
        text: 'Celková cena',
        value: 'price'
      },
      {
        text: 'Typ platby',
        value: 'paymentType'
      },
      {
        text: 'Zaplaceno',
        value: 'paid'
      },
      {
        text: '',
        value: 'actions'
      }
    ],
    deliveredDeliveriesAll: [],
    pickedDeliveriesAll: [],
    notPickedDeliveriesAll: [],
    search: '',
    headers: [
      {
        text: 'Název instituce / Jméno',
        value: 'name'
      },
      {
        text: 'Ulice',
        value: 'street'
      },
      {
        text: 'čp',
        value: 'streetNumber'
      },
      {
        text: 'Město',
        value: 'city'
      },
      {
        text: 'PSČ',
        value: 'zip'
      },
      {
        text: 'Městská část',
        value: 'cityDistrict'
      },
      {
        text: 'Telefon',
        value: 'phone1'
      },
      {
        text: 'Denní doba',
        value: 'time'
      }
    ],
    headersWithDriver: [
      {
        text: 'Název instituce / Jméno',
        value: 'name'
      },
      {
        text: 'Ulice',
        value: 'street'
      },
      {
        text: 'čp',
        value: 'streetNumber'
      },
      {
        text: 'Město',
        value: 'city'
      },
      {
        text: 'PSČ',
        value: 'zip'
      },
      {
        text: 'Městská část',
        value: 'cityDistrict'
      },
      {
        text: 'Řidič',
        value: 'driverEmail'
      },
      {
        text: 'Telefon',
        value: 'phone1'
      },
      {
        text: 'Denní doba',
        value: 'time'
      }
    ],
    driverDeliveries: [],
    timeTypes: []
  }),
  created () {
    this.initialize()
  },
  computed: {
    notPickedDeliveries () {
      if (!this.selectedTime) {
        return this.notPickedDeliveriesAll
      }

      return this.notPickedDeliveriesAll.filter(delivery => {
        return delivery.timeType === this.selectedTime.id
      })
    },
    pickedDeliveries () {
      if (!this.selectedTime) {
        return this.pickedDeliveriesAll
      }

      return this.pickedDeliveriesAll.filter(delivery => {
        return delivery.timeType === this.selectedTime.id
      })
    },
    pickedDeliveredDeliveries () {
      if (!this.selectedTime) {
        return this.deliveredDeliveriesAll
      }

      return this.deliveredDeliveriesAll.filter(delivery => {
        return delivery.timeType === this.selectedTime.id
      })
    },
    ...mapGetters({ currentUser: 'user/currentUser' }),
    deliveriesOrdered () {
      return this.$refs.deliveriesTable.selectableItems
    },
    driverDeliveriesOrdered () {
      return this.$refs.driverDeliveriesTable.selectableItems
    }
  },
  methods: {
    initialize () {
      if (this.currentUser.roleId === 4) {
        this.$http.get(`/users/${this.currentUser.id}`)
          .then(response => {
            const data = this.keysToCamelCase(response.data)

            const localS = JSON.parse(localStorage.getItem('user'))
            localStorage.setItem('user', JSON.stringify({
              ...localS,
              ...data
            }))
            this.setUserData({
              ...this.currentUser,
              ...data
            })
          })
      }
      this.getTimeTypes()
      this.getDeliveries()
    },
    getTimeTypes () {
      this.$http.get('/admin/times')
        .then(response => {
          this.timeTypes = this.keysToCamelCase(response.data)
        })
        .catch(err => console.log(err))
    },
    getDeliveries () {
      this.getNotPickedDeliveries()
      if (this.currentUser.roleId === 4) {
        this.getPickedDeliveriesDriver()
      } else {
        this.getPickedDeliveriesAdmin()
        this.getPickedDeliveredDeliveriesAdmin()
      }
    },
    finish (item) {
      this.loadingDriverDeliveries = true
      this.$http.post('/admin/order-confirm', {
        order_day_item_ids: item.orderDayItemIds
      })
        .then(() => {
          if (this.currentUser.roleId === 4) {
            this.getPickedDeliveriesDriver()
          } else {
            this.getPickedDeliveriesAdmin()
          }
        })
        .finally(() => {
          this.loadingDriverDeliveries = false
        })
    },
    getPickedDeliveriesAdmin () {
      this.loadingDriverDeliveries = true
      this.toolbarButtonsVisible = false
      this.$http.post('/admin/delivery/picked', {
        date: this.dateFilterPicked
      })
        .then(response => {
          this.toolbarButtonsVisible = true
          const mapped = this.mapDeliveries(this.keysToCamelCase(response.data))
          // console.log(mapped, 'mapped')
          this.pickedDeliveriesAll = this.extractDriver(mapped)
          this.toolbarButtonsVisible = true
        })
        .catch(err => {
          console.log(err)
        })
        .finally(() => {
          this.loadingDriverDeliveries = false
        })
    },
    getPickedDeliveredDeliveriesAdmin () {
      this.loadingDriverDeliveries = true
      this.toolbarButtonsVisible = false
      this.$http.post('/admin/delivery/pickedDelivered', {
        date: this.dateFilterDelivered
      })
        .then(response => {
          this.toolbarButtonsVisible = true
          const mapped = this.mapDeliveries(this.keysToCamelCase(response.data))
          // console.log(mapped, 'mapped')
          this.deliveredDeliveriesAll = this.extractDriver(mapped)
          this.toolbarButtonsVisible = true
        })
        .catch(err => {
          console.log(err)
        })
        .finally(() => {
          this.loadingDriverDeliveries = false
        })
    },
    getPickedDeliveriesDriver () {
      this.toolbarButtonsVisible = false
      this.loadingDriverDeliveries = true
      this.$http.post('/admin/delivery/pickedBy', {
        date: this.dateFilterPicked
      })
        .then(response => {
          this.toolbarButtonsVisible = true
          this.pickedDeliveriesAll = this.mapDeliveries(this.keysToCamelCase(response.data))
          this.toolbarButtonsVisible = true
        })
        .catch(err => {
          console.log(err)
        })
        .finally(() => {
          this.loadingDriverDeliveries = false
        })
    },
    getNotPickedDeliveries () {
      this.toolbarButtonsVisible = false
      this.$http.post('/admin/delivery', {
        date: this.dateFilter
      })
        .then(response => {
          this.toolbarButtonsVisible = true
          let tmp
          if (this.currentUser.roleId === 4) {
            tmp = this.keysToCamelCase(response.data).filter(dest => {
              const driverDistrictIds = this.currentUser.districts.map(d => d.id)
              return driverDistrictIds.includes(+dest.delivery?.cityDistrict.id || +dest.cityDistrict.id)
            })
          } else {
            tmp = this.keysToCamelCase(response.data)
          }
          this.notPickedDeliveriesAll = this.mapDeliveries(tmp)
          this.toolbarButtonsVisible = true
        })
        .catch(err => {
          console.log(err)
        })
    },
    /**
     * @name Meal
     * @type {{
     *   name: String,
     *   orderDayItemIds: Number[],
     *   paid: Number|Boolean,
     *   price: Number,
     *   quantity: Number,
     *   timeId: Number
     * }}
     */

    /**
     * @name SubjectWithDeliveries
     * @type {{
        firstName: String, lastName:String,
        name: String,
        phone1: String,
        deliveryStreet: String|null,
        deliveryStreetNumber: String|null,
        deliveryCity: String|null,
        deliveryZip: String|null,
        deliveryCityDistrict: Object|null,
        deliveryCityDistrictId: Number|null,
        street: String,
        streetNumber: String,
        city: String,
        zip: String,
        cityDistrict: Object,
        paymentTypes: {
          1: Meal[],
          3: Meal[],
          4: Meal[],
          5: Meal[]
        }
      }}
     */
    /**
     * @param {SubjectWithDeliveries[]} inputArr
     * @return {*[]}
     */
    mapDeliveries (inputArr) {
      let offset = 0
      const result = []
      inputArr.forEach((subject, index) => {
        subject.name = subject.name || `${subject.firstName} ${subject.lastName}`
        const deliveryItems = [[], [], [], [], [], []]

        Object.keys(subject.paymentTypes).forEach(paymentType => {
          const meals = subject.paymentTypes[paymentType]

          meals.forEach(meal => {
            let mealPayment
            switch (+paymentType) {
              case 1:
                mealPayment = 'Kredit'
                break
              case 3:
                mealPayment = 'Při převzetí'
                break
              case 4:
                mealPayment = 'Bankovní převod'
                break
              case 5:
                mealPayment = 'Kartou online'
                break
            }

            meal.paid = meal.paid ? 'Ano' : 'Ne'

            meal.foodTypesStr = meal.foodTypes
              .map(foodTypes => foodTypes.name)
              .join(', ')
            deliveryItems[meal.timeId - 1].push({
              ...meal,
              paymentType: mealPayment
            })
          })
        })

        deliveryItems.forEach((time, index) => {
          const timeName = this.timeTypes.find(tt => tt.id === index + 1).name
          if (time.length) {
            result.push({
              name: subject.name,
              street: subject.delivery?.deliveryStreet || subject.street,
              streetNumber: subject.delivery?.deliveryStreetNumber || subject.streetNumber,
              city: subject.delivery?.deliveryCity || subject.city,
              zip: subject.delivery?.deliveryZip || subject.zip,
              timeType: index + 1,
              time: timeName,
              items: [...time],
              phone1: subject.phone1,
              cityDistrict: subject.delivery?.cityDistrict.name || subject.cityDistrict.name,
              index: offset++
            })
          }
        })
      })

      return result
    },
    /**
     * @param  deliveryArr SubjectWithDeliveries[]
     * @return {*[]}
     */
    extractDriver (deliveryArr) {
      const result = []
      deliveryArr.forEach(delivery => {
        // itemy serazeny podle driver id vzestupne
        const itemsByDriver = delivery.items.sort((a, b) => a.driver.id - b.driver.id)

        // pole pro jednotlive ridice objednavky
        const driverItems = []
        let prevId = 0

        for (let i = 0; i < itemsByDriver.length; i++) {
          // novy ridic se prida do pole
          // i s jidlem
          if (itemsByDriver[i].driver.id !== prevId) {
            driverItems.push({
              email: itemsByDriver[i].driver.email,
              items: [itemsByDriver[i]]
            })
          } else {
            // jinak se jidlo prida poslednimu ridici v poli
            driverItems[driverItems.length - 1].items = driverItems[driverItems.length - 1].items.concat(itemsByDriver[i])
          }
          prevId = itemsByDriver[i].driver.id
        }

        for (let i = 0; i < driverItems.length; i++) {
          result.push({
            ...delivery,
            driverEmail: driverItems[i].email,
            items: driverItems[i].items
          })
        }
      })

      // add index for datatable
      return result.map((r, i) => {
        r.index = i
        return r
      })
    },
    exportExcel () {
      const itemsToExport = this.activeTab ? this.pickedDeliveries : this.notPickedDeliveries
      const workbook = new ExcelJS.Workbook()
      const exportWithDriver = this.activeTab && this.currentUser.roleId !== 4
      const sheet = workbook.addWorksheet('Rozvoz')
      sheet.mergeCells('A1:C1')
      sheet.getCell('A1').value = `Rozvoz – ${this.activeTab ? 'převzato' : 'k rozvozu'}`

      const now = new Date()
      const nowCzDate = now.toLocaleDateString('cs-CZ', {
        year: 'numeric',
        month: 'long',
        day: 'numeric'
      })
      const nowCzTime = now.toLocaleTimeString([], {
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit'
      })
      sheet.mergeCells('A2:C2')
      sheet.getCell('A2').value = `${nowCzDate} ${nowCzTime}`

      const headers = !this.activeTab ? this.headers : this.currentUser.roleId !== 4 ? this.headersWithDriver : this.headers
      sheet.getRow(4).values = headers.map(h => h.text)

      const columns = [
        { key: 'street', width: 20 },
        { key: 'streetNumber', width: 40 },
        { key: 'city', width: 20 },
        { key: 'zip', width: 10 },
        { key: 'name', width: 30 },
        { key: 'time', width: 20 }
      ]

      if (exportWithDriver) {
        sheet.getRow(4).values.splice(5, 0, 'Řidič')
        columns.splice(5, 0, {
          key: 'driverEmail',
          width: 20
        })
      }

      sheet.columns = columns

      let rowOffset = 5
      itemsToExport.forEach((delivery, index) => {
        sheet.getRow(rowOffset++).values = delivery

        sheet.getRow(rowOffset++).values = [
          '',
          'Název',
          'Množství',
          'Cena',
          'Typ platby',
          'Zaplaceno'
        ]

        delivery.items.forEach(item => {
          sheet.getRow(rowOffset++).values = [
            '',
            item.name,
            item.quantity,
            item.price,
            item.paymentType,
            item.paid
          ]
        })
      })
      sheet.eachRow(row => {
        row.eachCell(cell => {
          cell.alignment = {
            vertical: 'middle',
            horizontal: 'right',
            wrapText: true
          }
        })
      })
      workbook.xlsx.writeBuffer().then(data => {
        const blob = new Blob([data],
          { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' })
        const url = window.URL.createObjectURL(blob)
        const anchor = document.createElement('a')
        anchor.href = url
        anchor.download = `export_rozvoz_${this.activeTab ? 'prevzato' : 'k_rozvozu'}.xlsx`
        anchor.click()
        window.URL.revokeObjectURL(url)
      })
    },
    exportPdf () {
      const activeTab = this.activeTab
      const itemsToExport = this.activeTab ? this.pickedDeliveries : this.notPickedDeliveries
      const now = new Date()
      const exportWithDrivers = this.activeTab && this.currentUser.roleId !== 4
      const nowCzDate = now.toLocaleDateString('cs-CZ', {
        year: 'numeric',
        month: 'long',
        day: 'numeric'
      })
      const nowCzTime = now.toLocaleTimeString([], {
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit'
      })
      pdfMake.vfs = pdfFonts.pdfMake.vfs
      const headers = !this.activeTab ? this.headers : this.currentUser.roleId !== 4 ? this.headersWithDriver : this.headers

      const tableDelivery = []
      itemsToExport.forEach(delivery => {
        const del = [
          delivery.street,
          delivery.streetNumber,
          delivery.city,
          delivery.zip,
          delivery.name,
          delivery.time
        ]
        if (exportWithDrivers) {
          del.splice(5, 0, delivery.driverEmail)
        }
        tableDelivery.push(del)

        // deliveryItems rows
        const itemHeaders = [
          '',
          'Název',
          'Množství',
          'Cena',
          'Typ platby',
          'Zaplaceno'
        ]
        if (exportWithDrivers) {
          itemHeaders.push('')
        }
        tableDelivery.push(itemHeaders)

        delivery.items.forEach(item => {
          const itemRow = [
            '',
            item.name,
            item.quantity,
            item.price,
            item.paymentType,
            item.paid
          ]
          if (exportWithDrivers) {
            itemRow.push('')
          }
          tableDelivery.push(itemRow)
        })
      })
      const docDefinition = {
        content: [
          {
            text: `Rozvoz – ${activeTab ? 'převzato' : 'k rozvozu'}`
          },
          {
            text: `${nowCzDate} ${nowCzTime}`
          },
          {
            table: {
              body: [
                headers,
                ...tableDelivery
              ]
            }
          }
        ]
      }
      pdfMake.createPdf(docDefinition).download(`export_rozvoz_${activeTab ? 'prevzato' : 'k_rozvozu'}`)
    },
    take (item) {
      this.loadingDeliveries = true
      this.$http.post('/admin/picking', {
        order_day_item_ids: item.orderDayItemIds
      })
        .then(() => {
          this.getDeliveries()
        })
        .finally(() => {
          this.loadingDeliveries = false
        })
    },
    ...mapMutations({ setUserData: 'user/setUserData' })
  },
  watch: {
    dateFilter () {
      this.getNotPickedDeliveries()
    },
    dateFilterPicked () {
      if (this.currentUser.roleId === 4) {
        this.getPickedDeliveriesDriver()
      } else {
        this.getPickedDeliveriesAdmin()
      }
    },
    dateFilterDelivered () {
      this.getPickedDeliveredDeliveriesAdmin()
    }
  }
}
</script>

<style scoped>

</style>
